<template>
  <div>
    <router-link v-if="linkRequired" :to="location">
      <slot>{{text}}</slot>
    </router-link>

    <slot v-if="!linkRequired">{{text}}</slot>
  </div>
</template>

<script>
export default {
  name: 'PlayerLinkOptional',

  props: {
    linkRequired: {
      type: Boolean,
      required: true,
    },

    playerId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'player',
    },
  },

  computed: {
    /** @returns {Object} */
    location() {
      const loc = {
        name: 'player_info',
        params: {
          playerId: this.playerId,
        },
      };
      return loc;
    },

    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.playerId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      } else {
        return idStr;
      }
    },
  },
};
</script>
